/**
 * Simple Custom Scrollbar for Collection Subheader
 */

document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('.collection__subheader__scroll-wrapper');

  wrappers.forEach((wrapper) => {
    const list = wrapper.querySelector('.collection__subheader__list');
    const thumb = wrapper.querySelector('.collection__subheader__scrollbar-thumb');

    if (!list || !thumb) return;

    let scrollTimeout;

    const updateScrollbar = () => {
      const hasOverflow = list.scrollWidth > list.clientWidth;
      wrapper.classList.toggle('has-overflow', hasOverflow);

      if (hasOverflow) {
        const scrollLeft = list.scrollLeft;
        const scrollWidth = list.scrollWidth;
        const clientWidth = list.clientWidth;
        const maxScroll = scrollWidth - clientWidth;

        // Calculate thumb width as percentage of total scrollbar width
        const thumbWidth = Math.max((clientWidth / scrollWidth) * 100, 5); // Min 5% width

        // Calculate thumb position - ensure it reaches 100% when fully scrolled
        let scrollRatio = scrollLeft / maxScroll;
        // Clamp the ratio to prevent overshooting
        scrollRatio = Math.min(Math.max(scrollRatio, 0), 1);

        const thumbPosition = scrollRatio * (100 - thumbWidth);

        thumb.style.width = `${thumbWidth}%`;
        thumb.style.transform = `translateX(${thumbPosition}%)`;
      }
    };

    const handleScroll = () => {
      wrapper.classList.add('scrolling');
      updateScrollbar();

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        wrapper.classList.remove('scrolling');
      }, 1000);
    };

    list.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', updateScrollbar, { passive: true });

    updateScrollbar();
  });
});
